export default {
    common: {
        fogTitle: "Full Outturn Guarantee (FOG)",
        menuFogFiles: 'FOG Files',
        menuPorts: 'Ports',
        menuPreferences: 'Administration',
        menuClients: 'Clients',
        name: 'Name',
        country: 'Country',
        currency: 'Currency',
        underwriter: 'Underwriter',
        company: 'Company',
        general: 'General',
        contacts: 'Contacts',
        commodityGroup: 'Commodity Group',
        clientRates: 'Client rates',
        underwriterRates: 'Underwriter Rates',
        cargoes: 'Cargos',
        cargo: 'Cargo',
        actions: 'Actions',
        quantity: 'Quantity',
        value: 'Value',
        supplier: 'Supplier',
        costs: 'Affiliate invoices',
        save: 'Save',
        remove: 'Delete',
        duplicate: 'Duplicate',
        saveAndClose: 'Save and close',
        btnGenerateInvoice: 'Generate Invoice',
        btnGenerateCreditNote: 'Generate Credit Note',
    },

    invoice: {
        amount: 'Amount',
        label: 'Label',
    },

    login: {
        formTitle: "Log to FOG",
        buttonLogin: "Login",
        buttonLostPassword: "Lost password ?",
        fieldEmail: "E-mail",
        fieldPassword: "Password",
    },

    fog: {
        export_fogs: "Fogs export",
        affiliate_invoices: 'Affiliate invoices',
        archived: 'Archived',
        comments: 'Comments',
        creditNote: 'Credit Note',
        invoice: 'Invoice',
        fogSettlement: 'FOG settlement for the referenced shipment',
        premiumCharges: 'Premium charges',
        additionalCharges: 'Additional Charges / discount',
        underwriterFogsPremium: 'Underwriter\'s FOG Premium',
        total: 'Total',
        overageLabel: 'Overage',
        brokerageReturnAsPerAgreement: 'Brokerage return as per agreement',


        brokerageReturn: 'Brokerage return',
        creationDate: 'Creation date',
        fileNb: 'File #',
        overageClientRate: 'Overage client (%)',
        overageUnderwriterRate: 'Overage underwriter (%)',
        client: 'Client',
        vessel: 'Vessel',
        underwriter: 'Underwriter',
        commodities: 'Commodities',
        overage: 'Use overage',
        notes: 'Notes',
        voyageNb: 'Voyage #',
        year: 'Year',
        loadCountry: 'Load Country',
        dischargeCountry: 'Discharge country',
        metricTonnes: 'Metric tons',
        costInvoice: 'Costs / Invoices',
        accountsDepartment: 'Accounts department',
        port: 'Port',
        filesUploaded: 'Documents Uploaded',
        filesReady: 'Documents Ready to be sent',

        tab: {
            general: 'General',
            cargoes: 'Cargos',
            filesUpload: 'Documents'
        },
    },

    coverType: {
        name: 'Cover type',
        CC: 'CC',
        MARINE_ONLY: 'Marine only',
        FOG_ONLY: 'FOG only',
        SIXTY_DAYS_STORAGE_AND_OVERLAND: '60 days storage + overland',
        STORAGE_OVER_SIXTY_DAYS: 'Storage over 60 days',
        TRANSHIPMENT: 'Transhipment',
    },

    client: {
        name: 'Name',
        currency: 'Currency',
        address: 'Address',
        gitCode: 'Git code',
        phone: 'Phone',
        fax: 'Fax',
        email: 'Email',
        vatRate: 'VAT Rate (%)',
        comments: 'Comments',
        rate: {
            name: 'Rate name',
            creationDate: 'Creation date',
            isMarineOnly: 'Is marine only',
            rate: 'Rate (%)',
            franchise: 'Franchise (%)',
        }
    },

    currency: {
        name: 'Name',
        isoCode: 'ISO Code',
        symbol: 'Symbol',
    },

    vessel: {
        name: 'Name',
        year: 'Year',
        oldName: 'Old name',
    },

    underwriter: {
        name: 'Name',
        isUnderwriter: 'Is underwriter',
        country: 'Country',
        rebateRate: 'Rebate rate (%)',
        prefTitle: 'Rates',
        rate: {
            name: 'Rate name',
            rate: 'Rate (%)',
            yearOfAddition: 'Year of addition',
        }
    },

    messages: {
        success: 'Successfully saved !',
        removed: 'Successfully deleted !'
    },

    contact: {
        name: 'Name',
        phone: 'Phone',
        mobile: 'Mobile',
        fax: 'Fax',
        email: 'Email',
        isArchived: 'Archived',
        button:{
            add: 'Create new contact'
        },
        mainContact: 'Main contact',
    },

    country: {
        isoCode: 'ISO Code',
    },

    commodities: {
        name: 'Name',
        commodityGroupName: 'Commodity Group'
    },

    cargo: {
        perTonUsd: 'Per tonne USD',
        customerReference: 'Customer reference',
        receiver: 'Receiver',
        blDate: 'BL date',
        blNumber: 'BL number',
        certificateReference: 'Certificate reference',
        stowage: 'Stowage',
        commodity: 'Commodity',
        underwriterRate: 'Underwriter rate (%)',
        clientRate: 'Client rate (%)',
        outturnTonnes: 'Outturn tonnes',
        shortageTonnes: 'Shortage tonnes',
        shortagePercent: 'Shortage percent (%)',
        outturnInformation: 'Outturn Information',
        excessExclusion: 'Excess Exclusion',
    },

    cargoSummary: {
        outturn: 'Outturn',
        value: 'Value',
        shortage_gain: 'Shortage/gain',
        shortage_percent: 'Shortage %',
        totalQuantity: 'Total Quantity',
    },

    costSummary: {
        value: 'Value',
    },

    cost: {
        label: 'Label',
        invoiceNumber: "Invoice #",
        company: "Affiliate",
        currency: "Currency",
        creationDate: "Creation date",
        approvalDate: "Approval date",
        invoiceDate: "Invoice date",
        totalCost: "Total cost",
        invoiceFile: "File",
    },

    port: {
        name: 'Name',
        country: 'Country',
        ports: 'Ports',
        load: 'Load port',
        discharge: 'Discharge port',
        eta: 'ETA (Estimated time of arrival)',
        etd: 'ETD (Estimated time of departure)',
        port: 'Port',
        isConfirmed: 'Is confirmed ?'
    },


    validation: {
        required: 'This field is required.',
        form_error: 'Some required information is missing or incomplete. Please correct your entries and try again.'
    }
}


// WEBPACK FOOTER //
// ./src/l10n/en.js